module.exports = __webpack_public_path__ + "4d341f408b8ba7ede5efec96b54ee034.png";